export const Carrinho = 1;
export const Rascunho = 2;
export const Pendente = 3;
export const Devolvido = 4;
export const Cancelado = 5;
export const Aprovado = 6;
export const Programado = 7;
export const Enviado = 8;
export const Concluido = 9;
export const ConcluidoComRessalvas = 10;
export const Preparacao = 11;
export const ProntoParaEntrega = 12;
export const Entregue = 13;
export const Criacao = 14;
export const Producao = 15;
export const Triagem = 16;
export const AprovacaoComercial = 17;
export const RevisaoInterna = 18;
export const AprovacaoDeArte = 19;
export const FechamentoDeArquivo = 20;
export const AguardandoProducao = 21;
export const Fornecedor = 22;
export const DisponivelParaRetirada = 23;
export const EmTransporte = 24;
export const Finalizado = 25;
export const AguardandoDevolucao = 26;
export const Transporte = 27;
export const Supervisao = 28;
export const AmostraDeCartao = 29;
export const Redatora = 30;
export const Orcamento = 31;
export const SupervisaoTrade = 32;
// export const AprovacaoDeRedacao = 33;


// WEBPACK FOOTER //
// ./src/config/StatusPedido.js